export const GAMBLING_SESSION_LIMITS_RESPONSIBLE_GAMING_LINK = 'gambling-session-limits-responsible-gaming-link';